const getters = {
  isLoading: state => state.isLoading,
  all: state => state.all,
};

export default getters;
